<template>
    <app-ghost-mode>
        <div class="row">
            <div class="col-md-6 col-sm-8 col-12">
                <form v-if="item">
                    <div class="jumbotron screen-center text-center">
                        <div class="negotiate-header bg-dark pt-3">
                            <h3 class="md-small-text">Generate Payment Link</h3>
                        </div>
                        <!-- Alert Messages -->
                        <dl v-if="msg !== ''" class="row mt-3">
                            <dd class="col-12">
                                <div :class="`alert alert-${color} text-center mb-n4 p-1`" role="alert">
                                    <i class="fas fa-exclamation-circle"></i> {{ msg }}
                                </div>
                            </dd>
                        </dl>
                        <div v-if="!item.sold" class="mt-4 mb-2">
                            <p class="font-weight-bold">"{{item.title}}"</p>
                            <p class="font-weight-bold text-dark-green text-uppercase">
                                <span v-if="item.onSale">
                                    <i class="fas fa-money-bill"></i> {{item.currency}} {{item.onSalePrice | money}}
                                </span>
                                <span v-else>
                                    <i class="fas fa-money-bill"></i> {{item.currency}} {{item.price | money}}
                                </span>
                            </p>
                        </div>
                        <template v-if="myItemBuyers">
                            <!-- displayed generated payment link here -->
                            <ul class="list-group text-center">
                                <li class="list-group-item">
                                    <!-- display receipt conf. box -->
                                    <template v-if="payObj && payObj.paid">
                                        <div class="row">
                                            <div class="col-12">
                                                <form>
                                                    <span class="text-dark-green">Receipt Confirmation Code</span>
                                                    <input type="text" v-model="confCodeBox" class="form-control text-center no-lines bg-white mb-2">
                                                    <button @click.prevent="verifyReceiptFxn" class="loadn btn btn-dark-green btn-sm">Verify Receipt</button>
                                                </form>
                                            </div>
                                        </div>
                                    </template>
                                    <!-- display generated payment link -->
                                    <template v-else>
                                        <span v-if="paymentLink === ''">
                                            <i class="fas fa-spinner fa-pulse"></i> generating link...
                                        </span>
                                        <div v-else class="row">
                                            <div class="col-12">
                                                <a :href="paymentLink" class="text-dark-green" target="blank" ref="myPayLink">
                                                    {{paymentLink}}
                                                </a>
                                            </div>
                                            <div @click.prevent="copyURL" class="col-12 mt-2 btn btn-dark btn-sm">
                                                <span v-if="copied">
                                                    <i class="fas fa-thumbs-up"></i> Payment link copied!
                                                </span>
                                                <span v-else>
                                                    <i class="fas fa-copy"></i> Click me to copy payment link
                                                </span>
                                            </div>
                                            <!-- link to see all previously generated payment links -->
                                            <div class="col-12 text-center mt-1">
                                                <small @click.prevent="showOldPayLinks = !showOldPayLinks" class="clickable">
                                                    <span class="text-danger" v-if="showOldPayLinks"><i class="fas fa-receipt"></i> Hide previous pay links</span>
                                                    <span v-else class="text-dark"><i class="fas fa-receipt"></i> Show previous pay links</span>
                                                </small>
                                                <!-- display the older payment links here -->
                                                <app-old-pay-link v-if="showOldPayLinks" :itemId="item._id" @emptyPayLink="emptyPayLinkFxn"></app-old-pay-link>
                                            </div>
                                        </div>
                                    </template>
                                </li>
                            </ul>
                        </template>
                        <template v-else>
                            <!-- ensure there is an interested buyer first -->
                            <ul class="list-group text-center">
                                <li class="list-group-item text-danger">
                                    Payment link for this item will appear here only when you have an interested buyer!
                                </li>
                            </ul>
                        </template>
                    </div>
                </form>
                <div v-else class="text-center text-danger">Ooops! You're missing the item!</div>
            </div>
        </div>
    </app-ghost-mode>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { copyTextFxn } from '@/store/dry'

import GhostMode from '@/components/general/shared/GhostMode.vue'
import OldPayLink from './OldPayLink.vue'

export default {
    name: "GenPayLink",
    props: ['itemId'],
    data() {
        return {
            showOldPayLinks: false,
            confCodeBox: '',
            paymentLink: '',
            payObj: null,
            copied: false,
            msg: '',
            color: 'danger'
        }
    },
    methods: {
        ...mapActions(['listPostedItem', 'fetchItemBuyers', 'generatePayLink', 'fetchPaymentLinks', 'completePayment']),
        emptyPayLinkFxn() {
            this.paymentLink = 'Payment Link Removed'
            this.color = 'danger'
            this.msg = ''
        },
        runFetchItemDetails() {
            // fetch the new item details using the itemId
            this.listPostedItem(this.itemId)
            .then(() => {
                this.runFetchItemBuyers()
            })
            .catch((e) => {})
        },
        runFetchItemBuyers() {
            let itemObj = {
                itemId: this.item._id,
                sellerId: this.item.userId
            }
            this.fetchItemBuyers(itemObj)
        },
        genPayLinkFxn() {
            let itemObj = {
                itemId: this.item._id,
                userId: this.user._id,
            }
            this.generatePayLink(itemObj)
            .then((data) => {
                if(!data.error){
                    this.color = "success"
                    this.payObj = data.result
                    this.paymentLink = `${process.env.VUE_APP_CLT_URL}/payments/item-payment/${this.payObj._id}`
                    // fetch the older payment links here
                    this.runFetchPaymentLinks()
                }
                this.msg = data.msg
            })
            .catch((e) => {
                this.color = "danger"
                this.msg = "Unable to generate payment link at this time, try again later."
            })
        },
        runFetchPaymentLinks() {
            // fetch the older payment links using the itemId
            let itemObj = {
                itemId: this.item._id,
                userId: this.user._id,
            }
            this.fetchPaymentLinks(itemObj).then(() => {}).catch((e) => {})
        },
        copyURL() {
            let itemPayUrl = this.$refs.myPayLink.innerText
            if(!itemPayUrl) return

            let itemUrl = process.env.VUE_APP_CLT_URL + "/market/listItem/" + this.item._id
            let itemPrice = this.item.onSale ? this.item.onSalePrice : this.item.price
            let copyPayNote = `aNewItem payment link, generated from @${this.user.userHandle} `
            copyPayNote += `shop for item "${this.item.title}" @ ${this.item.currency.toUpperCase()} ${itemPrice} only. `
            copyPayNote += `Click the link below to make payment for this item. `
            copyPayNote += `\n\n${itemPayUrl}`

            this.copied = true
            setTimeout(() => {
                this.copied = false
            }, 1000)
            copyTextFxn(copyPayNote)
        },
        verifyReceiptFxn() {
            this.color = 'danger'
            if(this.confCodeBox === ''){ this.msg = "Enter the receipt confirmation code to proceed!"; return }
            let paymentObj = {
                confirmationCode: this.confCodeBox
            }
            this.completePayment(paymentObj)
            .then((data) => {
                if(!data.error){
                    this.color = "success"
                    
                    // convert to string and store the receipt details obj
                    localStorage.setItem('_p89rc49s', JSON.stringify(data.result))
                    
                    // redirect to the payment receipt page using the payment-details-id
                    window.location = `${process.env.VUE_APP_CLT_URL}/payments/item-payment/${data.result.paymentId}`
                }
                this.msg = data.msg
            })
            .catch((e) => {
                this.color = "danger"
                this.msg = "Unable to verify payment receipts at this time, try again later."
            })
        }
    },
    computed: {
        ...mapGetters(['postedItem', 'user', 'masItemBuyers']),
        item() {
            if(this.postedItem && this.postedItem !== null){
                return this.postedItem
            }
            return false
        },
        myItemBuyers() {
            if(this.masItemBuyers && this.masItemBuyers.length > 0){
                // ensure item has potential buyers before running the payment link generator
                this.payObj = null
                this.paymentLink = ''
                this.genPayLinkFxn()
                return true
            }
            return false
        }
    },
    components: {
        appGhostMode: GhostMode,
        appOldPayLink: OldPayLink
    },
    mounted() {
        this.runFetchItemDetails()
    }
}
</script>